import React from 'react';
import Button from '../Button/Button';
import styles from './DeleteModal.module.css';

type DeleteModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
    branchName: string;
    /** Optional custom message. When not provided, uses default: "All the data will be deleted and this action is irreversible." */
    message?: string;
};

const DEFAULT_DELETE_MESSAGE = 'All the data will be deleted and this action is irreversible.';

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, onClose, onDelete, branchName, message }) => {
    const descText = message ?? DEFAULT_DELETE_MESSAGE;
    // #1201: Only render when open to prevent ghost Cancel/Delete buttons
    if (!isOpen) return null;
    return (
        <div className={`${styles.modalOverlay} ${styles.open}`}>
            <div className={`${styles.modalContent} ${isOpen ? styles.open : ''}`}>
                <button className={styles.closeButton} onClick={onClose} aria-label="Close">&times;</button>
                <div className={styles.textContainer}>
                    <h2 className={styles.header}>Delete {branchName}</h2>
                    <p className={styles.descText}>{descText}</p>
                </div>
                <div className={styles.buttonsContainer}>
                    <Button label="Cancel" onClick={onClose} noAppearance={true} size='small' />
                    <div>
                        <Button label="Delete" onClick={onDelete} size='medium' backgroundColor='var(--destructive-fill)' fontColor='var(--on-destructive)' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
